import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-plum-50 py-16 md:py-24" data-id="element-49" data-mp="1gcxo0dofypwm">
      <div className="mx-auto w-full max-w-narrow px-5 md:px-8" data-id="element-50" data-mp="1gakztis3bjb4">
        <SectionHeading eyebrow="Antes de comprar" title={<>
              Preguntas <span className="italic text-gold-700" data-id="element-52" data-mp="292o6t010qfz2">frecuentes</span>
            </>} data-id="element-51" data-mp="2dzen9ogqjdl0" />

        <ul className="mt-12 space-y-3" data-id="element-53" data-mp="240p29mtjld0j">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} className="overflow-hidden rounded-xl bg-white shadow-card" data-id="element-54" data-mp="smv26fb4eg6g" data-mpi={index}>
                <h3 data-id="element-55" data-mp="noa0sck4tqgf">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:bg-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-plum-300 md:px-8" data-id="element-56" data-mp="nnqszoo74ig4">
                    <span className="font-display text-lg font-bold text-plum-700 md:text-xl" data-id="element-57" data-mp="kkxs508j0iyk">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-teal-500 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-58" data-mp="bj81hwmgxo1u" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-59" data-mp="3nzk3lns3n9cn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-60" data-mp="3o1o37tiytm74">
                      <div className="space-y-3 px-6 pb-6 text-muted md:px-8" data-id="element-61" data-mp="1fszwamlx4jgn">
                        {faq.answer.map(line => <p key={line} className="leading-relaxed" data-id="element-62" data-mp="2ddmckomi3p3l">
                            {line}
                          </p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}